import { AmacUrl, Page } from 'src/common/routes';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import useToken from 'src/common/useToken';
import moment from 'moment';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { Capacitor } from '@capacitor/core';

const getLandingPath = () =>
  Capacitor.isNativePlatform() ? AmacUrl.Contacts : AmacUrl.Dashboard;

export default function ProtectedRoute(props) {
  const urlPath = window.location.pathname; // e.g., "/ca/admin"
  const part = urlPath.split('/')[1];
  const { token } = useToken();
  const email = localStorage.getItem('email');
  let navigate = useNavigate();
  const { state } = useParams();
  const Access_State = localStorage.getItem('Access_State');
  console.log('Access_State Protected ==> ', Access_State);

  const Expiretime = Number(localStorage.getItem('Expiretime'));
  const newtime = Date.now();

  const startDate = moment(Expiretime);
  const timeEnd = moment(newtime);
  const diff = timeEnd.diff(startDate);
  const diffDuration = moment.duration(diff);
  // const diffMin = diffDuration.minutes(); // Minutes
  const diffWeeks = diffDuration.asWeeks();  // Get the difference in weeks
  const URL = window.location.href;
  const path = window.location.pathname;
  //alert(diffMin);
  //alert(diffMin);

  // if (diffWeeks > 30 {
  if (diffWeeks > 1) {   // Check if the difference is more than 1 week
    if (
      token &&
      !URL.includes(AmacUrl.Statistics) &&
      !URL.includes(AmacUrl.Stats) &&
      !URL.includes(AmacUrl.CommunityDemographicsHome) &&
      !URL.includes(AmacUrl.Candidates) &&
      !URL.includes(AmacUrl.PrimaryElection2025Home) &&
      !URL.includes(AmacUrl.ElectionNov2025Home)
    ) {
      localStorage.clear();
      setGlobalState('loggedin', false);
      setGlobalState('sessionerror', 'Unauthorized');
      return <Navigate to={`/${AmacUrl.Login}`} replace />;
    }
  }

  console.log('path => ' + path);

  if (!token) {
    return <Navigate to={`/${Page.Login}`} replace />;
  }

  if (path == `/${part}`) {
    return <Navigate to={`/${Page.Login}`} replace />;
  }

  if (
    token &&
    !URL.includes(AmacUrl.Statistics) &&
    !URL.includes(AmacUrl.Stats) &&
    !URL.includes(AmacUrl.CommunityDemographicsHome) &&
    !URL.includes(AmacUrl.Candidates) &&
    !URL.includes(AmacUrl.PrimaryElection2025Home) &&
    !URL.includes(AmacUrl.ElectionNov2025Home)
  ) {
    // if(URL.includes(AmacUrl.Statistics)) {
    //   console.log('Avoid redirect 01')
    //   return
    //   // return window.open(AmacUrl.Statistics, '_self');
    // }
    const userRole = localStorage.getItem('Access_Urm');

    console.log('ProtectedRoute URL => ' + URL);
    if (
      (URL.includes('users-management') ||
        URL.includes('search-voters-dynamodb') ||
        URL.includes('search-voters-clickhouse')) &&
      userRole != '1' &&
      userRole != '2'
    ) {
      console.log('Not Allowed');
      return <Navigate to={`/${Access_State}/${AmacUrl.Dashboard}`} replace />;
    } else {
      if (!path.startsWith(`/${Access_State}/`)) {
        console.log('Condition Else ====');
        const pathSplit = path.split(`/${state}/`);
        console.log('pathSplit ===> ', pathSplit);
        const remainingPath = pathSplit[1];
        console.log('remainingPath ===> ', remainingPath);
        // return <Navigate to={`/${Access_State}/${remainingPath}`} replace />;
        return window.open(`/${Access_State}/${remainingPath}`, '_self');
        // const newPath = currentPath.replace('/ca/', '/wa/');
        // navigate(newPath, { replace: true });
      }
    }
    // return <Navigate to={AmacUrl.Dashboard} replace />;
  }

  console.log('Falls here');
  console.log(props.children);

  return props.children;
}

export function SessionMaintained(props) {
  const { token } = useToken();
  const { state } = useParams();
  const urlPath = window.location.pathname; // e.g., "/ca/admin"
  const part = urlPath.split('/')[1];
  const path = window.location.pathname;
  const URL = window.location.href;
  const Access_State = localStorage.getItem('Access_State');
  const landingPath = getLandingPath();
  console.log('Access_State Session ==> ', Access_State);
  console.log('Session URL => ' + URL);
  console.log('part ==', '<<<' + part + '>>>', 'Path == ', path);

  if (part == 'undefined') {
    return <Navigate to={`/${Page.Login}`} replace />;
  }
  // if(URL.includes(AmacUrl.Statistics)) {
  //   console.log('Avoid redirect 02')
  //   return;
  //   // return window.open(AmacUrl.Statistics, '_self');
  // }

  // if (!path.includes('/ca') && !path.includes('/wa')) {
  //   // return window.open(`${Page.Statistics}`, '_self');
  //   return <Navigate to={`${part}/${AmacUrl.Statistics}`} replace />;
  //   // return <Navigate to={`wa/${Page.Statistics}`} replace />;
  // }

  if (
    token &&
    !URL.includes(AmacUrl.Statistics) &&
    !URL.includes(AmacUrl.Stats) &&
    !URL.includes(AmacUrl.CommunityDemographicsHome) &&
    !URL.includes(AmacUrl.Candidates) &&
    !URL.includes(AmacUrl.PrimaryElection2025Home) &&
    !URL.includes(AmacUrl.ElectionNov2025Home)
  ) {
    // return window.open(
    //   `${window.location.origin}/${part}/${AmacUrl.Dashboard}`,
    //   '_self'
    // );
    if (part == 'ca' || part == 'wa') {
      console.log('Condition 1');
      return <Navigate to={`/${Access_State}${landingPath}`} replace />;
    } else if (part == 'undefined') {
      console.log('Condition 3');
    } else if (part != 'ca' && part != 'wa') {
      console.log('Condition 2');
      return <Navigate to={`/${Access_State}${landingPath}`} replace />;
    }
  }

  if (path == '/') {
    // return window.open(`wa/${Page.Statistics}`, '_self');
    return <Navigate to={`/wa/${Page.Login}`} replace />;
  }

  // if (path != 'wa' && path != 'ca') {
  //   console.log('part', part);

  //   // return (window.location.href = window.location.origin + '/wa/home');
  //   // <Navigate to={Page.Statistics} replace />;
  // }

  return props.children;
}
